import React, { useState, useRef, useEffect } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';
import CommonBtn from '@views/components/CommonBtn';
import CallNameMenu from './CallNameMenu';
import ConfirmModal from '@views/components/ConfirmModal';
import Http from '@helpers/Http';
import { Api } from '@apis/client';

import userStore from '@stores/user';
import * as Cache from '../../../../../app/helpers/Cache';
import { IDeviceBindInfo } from '@apis/types';
import { pushAndPopUntil } from '@helpers/BrowserHistory';
import { ResultType } from '../DeviceBindResult';
import FridayService from '@services/friday';

const DeviceBindApply = () => {
  const deviceBindInfo = useRef<IDeviceBindInfo>(Cache.get('deviceBindInfo'));
  const [callName, setCallName] = useState('');
  const [showPopMenu, setShowPopMenu] = useState(false);
  const customName = useRef('');

  const renderItems = () => {
    const items = ['与孩子通话', '与孩子聊天', '实时查看孩子定位', '设置学生证通话号码'].map((text) => {
      return (
        <div className='flex' styleName='li-container'>
          <i styleName='li-dot' className="iconfont icon-caret-dot"/>
          <span>{text}</span>
        </div>
      );
    });
    return (
      <div className='flex' styleName='ul-container'>
        {items}
      </div>
    );
  }

  const getAdminText = (): string => {
    const phone = deviceBindInfo.current.phone || '';
    const ownerName = deviceBindInfo.current.ownerName || '';
    if (phone.length <= 0) {
      return ownerName.slice(0, 1) + '*'.repeat(ownerName.length - 1);
    } else {
      return ownerName.slice(0, 1) + '*'.repeat(ownerName.length - 1) + ' ' + phone.slice(0, 3) + '*'.repeat(4) + phone.slice(7);
    }
  }

  const readCustomName = (e: any) => {
    const text = e.target.value;
    customName.current = text;
  }

  const onCustomNameConfirm = () => {
    if(customName.current.trim().length > 0) {
      setCallName(customName.current.trim());
    }
  }

  const onCustomNameInput = () => {
    ConfirmModal.show({
      title: '自定义亲属关系',
      height: '4.68rem',
      showCancelBtn: true,
      cancelBtnText: '取 消',
      confirmBtnText: '确 定',
      onConfirm: onCustomNameConfirm,
      ContentWidget: (
      <div className='flex' styleName='input-container'>
        <input placeholder='请输入亲属关系' maxLength={10} onChange={readCustomName} defaultValue={customName.current}/>
      </div>)
    });
  }

  const postApplication = () => {
    FridayService.addEvent('application_binding_send_application_button_click');
    Http.post(
      Api.PostDeviceBindApplication,
      {
        applicantUid: userStore.userInfo.uid,
        approverUid:  deviceBindInfo.current.ownerUid,
        applyCode: 'PARENT_JOIN_CLASS',
        targetUid: deviceBindInfo.current.bindUserUid,
        targetType: 0,
        applyContent: {
          parentName: `${deviceBindInfo.current.bindUserName}${callName}`,
          studentUid: deviceBindInfo.current.bindUserUid,
          studentName: deviceBindInfo.current.bindUserName,
          unitUid: deviceBindInfo.current.bindSchoolUid,
          parentPhone: userStore.userInfo.phone
        }
      }
    ).then(async() => {
      pushAndPopUntil(`${PUBLIC_URL}/devicebindresult?type=${ResultType.SUCCESS}`, ['/devicebindresult', '/']);
    });
  }

  useEffect(() => {
    FridayService.addEvent('application_binding_self_show');
  }, []);

  return (
    <div styleName="container">
      <NavBar
        title="申请绑定"
      />
      <div className='flex' styleName='content'>
        <p styleName='title'>当前设备已绑定</p>
        <p>{`请向管理员（${getAdminText()}）发送绑定申请，通过后才可绑定`}</p>
        <div className='flex' styleName='call-name-input' onClick={() => setShowPopMenu(true)}>
          <p styleName='input-title'>{callName ||'请选择孩子对你的称呼'}</p>
          <i styleName='right-arrow' className="iconfont icon-tubiaoyanse"/>
        </div>
        <p styleName='ul-title'>绑定成功后将获得的以下权限</p>
        {renderItems()}
        <CommonBtn
          btnText="发送申请"
          disabled={callName.length <= 0}
          style={{ position:'absolute', bottom: '0.32rem', left: 0, right: 0,  width: '90%'}}
          onConfirm={postApplication}
      />
      {
        showPopMenu ? (
          <CallNameMenu
            onClose={ () => setShowPopMenu(false) }
            onNameSelected={(name) => setCallName(name)}
            onCustomName={onCustomNameInput}
          />
        ) : null
      }
      </div>
    </div>
  )
}

export default DeviceBindApply;
